import { FunctionComponent } from 'react';
import { NavigationBlock } from '@cbridge-tools/navigation-block';
import { useTranslation } from 'react-i18next';
import { useSelector } from '@cbridge-utils/react-redux';
import { CreateMarkupProfileButton } from './createButton/CreateMarkupProfileButton';
import { MarkupProfileItem } from './navigationItem/MarkupProfileItem';
import { markupProfilesNavigationPropsSelector } from './MarkupProfilesNavigation.selector';

export const MarkupProfilesNavigation: FunctionComponent = () => {
  const { t } = useTranslation();

  const { items, isLoading } = useSelector(markupProfilesNavigationPropsSelector);

  return (
    <NavigationBlock
      header={t('text:configPage.markups.title')}
      headerAction={<CreateMarkupProfileButton />}
      items={items}
      isLoading={isLoading}
      NavigationItemComponent={MarkupProfileItem}
    />
  );
};
